function ModalBody({children}) {
    return (children &&
        <div className="modal__body">
            {children}
        </div>
    )
}

export default ModalBody;